import Clipboard from "clipboard";
import {Toast} from "vant";

export function fnCopy(copyText) {
    const clip = new Clipboard("body", {
        text: function() {
            return copyText;
        }
    });
    Toast.success("已经复制到剪切板");
    setTimeout(() => {
        clip.destroy();
    }, 0)
}